import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { InsuredMemberModel } from '../models/interfaces/insured-member.model';

@Injectable({
    providedIn: 'root'
})
export class InsuredMemberSearchService {

    readonly DEFAULT_PAGE_SIZE = 15;
    readonly BASE_URL = '/benefits-api/benefits-admin';

    constructor(
        private httpClient: HttpClient
    ) {}

    searchMember(sponsorId: number, page: number, firstName: string, lastName: string, dateOfBirth?: string, subscriberId?: string): Observable<any> {
        const headers = new HttpHeaders();
        const fromObject: any = {
            firstName: firstName,
            lastName: lastName,
            pageSize: this.DEFAULT_PAGE_SIZE,
            page: String(page - 1),
            ...(subscriberId && { subscriberId }),
            ...(dateOfBirth && { dateOfBirth })
        };

        const params = new HttpParams({ fromObject });

        return this.httpClient.get<any>(`${this.BASE_URL}/sponsor/${sponsorId}/insured-member/search`, { headers, observe: 'response', params })
            .pipe(
                map((responseWithHeaders: any) => {
                    return {
                        count: parseInt(responseWithHeaders.headers.get('content-items'), 10),
                        totalPages: parseInt(responseWithHeaders.headers.get('total-pages'), 10),
                        currentPage: parseInt(responseWithHeaders.headers.get('current-page'), 10),
                        data: responseWithHeaders.body
                    };
                })
            );
    }

    getDigitalIdCardDependants(sponsorId: number, claimantId: number): Observable<InsuredMemberModel[]> {
        const headers = new HttpHeaders();

        const url = `${this.BASE_URL}/sponsor/${sponsorId}/insured-member/${claimantId}/dependants`;
        return this.httpClient
            .get<InsuredMemberModel[]>(url, {
                headers: headers,
                observe: 'body'
            })
            .pipe(
                map((response) =>
                    response.map((item) => ({
                        ...item,
                        name: `${item.firstName} ${item.lastName}`
                    }))
                )
            );
    }
}
